module.exports = __webpack_public_path__ + "static/mr-press-18-ce95a280c49fbd019264c66e51432e33.jpg";